import { initializeApp } from "firebase/app";
import { FacebookAuthProvider, getAuth, GoogleAuthProvider, sendEmailVerification,OAuthProvider } from "firebase/auth";

// old demo
// const firebaseConfig = {
//   apiKey: "AIzaSyDPUujGGsIJ4vbkdgQ7W-JKGMyZZliAhZw",
//   authDomain: "castingbell-demo.firebaseapp.com",
//   projectId: "castingbell-demo",
//   storageBucket: "castingbell-demo.appspot.com",
//   messagingSenderId: "880662193521",
//   appId: "1:880662193521:web:0ac7912b8ca24075b782d0",
//   measurementId: "G-302S4CT5HP"
  // };
// live
const firebaseConfig = {
  apiKey: "AIzaSyBiPF6YJTshansEvC4W3qztFMtlvul0kn8",
  authDomain: "castingbellindia.firebaseapp.com",
  projectId: "castingbellindia",
  storageBucket: "castingbellindia.appspot.com",
  messagingSenderId: "601876832145",
  appId: "1:601876832145:web:1fb23c0d4b1d4adb04c430",
  measurementId: "G-9L5QB03FV0"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: 'select_account'
});
provider.addScope('profile');
provider.addScope('email');


const fbProvider = new FacebookAuthProvider();
fbProvider.addScope('email');

fbProvider.setCustomParameters({
  display: "popup",
});

const Appleprovider = new OAuthProvider('apple.com')
Appleprovider.addScope('email');
Appleprovider.addScope('name');

export { auth, provider, app, fbProvider, Appleprovider };



// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCUDFP99I_b6Y5A5T3zMo3lpMObTyW9Yh8",
//   authDomain: "castingbell-007.firebaseapp.com",
//   projectId: "castingbell-007",
//   storageBucket: "castingbell-007.appspot.com",
//   messagingSenderId: "650708362520",
//   appId: "1:650708362520:web:5d83fd2f846e8dca766a6d",
//   measurementId: "G-3Y3HNDXS53"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);